<sb-card>
  <div card-header classes="no-border">
    <sb-search-bar (searchAction)="doSearch($event)"
                   [searchStr]="search"
                   [subline]="paginationString"
                   headline="{{ translate.instant('lang.inventory.' + currentSelection?.type) }}"
                   placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
                   searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
                   stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"></sb-search-bar>
  </div>
  <div card-header-more class="d-flex align-items-center">
    <div class="mr-2">
      <select class="form-select" [(ngModel)]="screenScope" (ngModelChange)="requestDebounced()">
        <option *ngFor="let i of screenScopes" [ngValue]="i">{{ translate.instant('lang.screenScope.' + i) }}</option>
      </select>
    </div>
    <app-inventory-scope-select (selectionChange)="scopeSelection($event)" [currentSelection]="currentSelection"
                                [inventoryFields]="inventoryFields"
                                class="mr-2"></app-inventory-scope-select>
    <sb-comp-dropdown-select (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
                             (selectedDataEmitter)="update($event, 'PLAYER_CULLS')"
                             *ngPermissions="permissionService.Permission.cull_list"
                             [disabled]="loading"
                             [dropDownDatatype]="'PLAYER_CULLS'" [inputData]="playerCulls"
                             [msOptions]="msPlayerCullOptions" [selectedInputData]="playerCull ? [playerCull] : []"
                             [showColumnIcon]="false" [showSubmit]="false"
                             [singleSelectMode]="true">
    </sb-comp-dropdown-select>
    <sb-comp-dropdown-select (msOptionsChange)="msRequest('GEO_CULLS', $event)"
                             (selectedDataEmitter)="update($event, 'GEO_CULLS')"
                             *ngPermissions="permissionService.Permission.cull_list"
                             [disabled]="loading"
                             [dropDownDatatype]="'GEO_CULLS'" [inputData]="geoCulls"
                             [msOptions]="msGeoCullOptions" [selectedInputData]="geoCull ? [geoCull] : []"
                             [showColumnIcon]="false" [showSubmit]="false"
                             [singleSelectMode]="true">
    </sb-comp-dropdown-select>
    <button (click)="exportInventory()" [disabled]="loading" class="btn btn-hover-primary">
      <sb-icon icon="download"></sb-icon>
      {{ 'lang.globals.export' | translate }}
    </button>
  </div>
  <div card-body>
    <table class="table content-table">
      <thead>
      <tr>
        <th>{{ 'lang.globals.name' | translate }}</th>
        <th
          *ngIf="currentSelection?.type === 'InventoryLocationDTO' || currentSelection?.type === 'InventoryClientDTO'">{{ 'lang.address.address' | translate }}
        </th>
        <th
          *ngIf="currentSelection?.type === 'InventoryChannelDTO' || currentSelection?.type === 'InventoryMarkerDTO'">{{ 'lang.globals.resolution' | translate }}
        </th>
        <th>{{ 'lang.globals.overview' | translate }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let ele of listItems">
        <tr>
          <td>
            <sb-comp-image-name-wrapper [image]="ele?.displayValue?.logo?.url">
              <span firstLine>ID: {{ ele?.displayValue?.id ?? '-' }}</span>
              <span secondLine>{{ 'lang.globals.identifier' |translate }}: {{ ele?.displayValue?.identifier ?? '-' }}</span>
              <span thirdLine>Name: {{ ele?.displayValue?.name ?? '-' }}</span>
            </sb-comp-image-name-wrapper>
          </td>

          <td
            *ngIf="currentSelection?.type === 'InventoryLocationDTO' || currentSelection?.type === 'InventoryClientDTO'">
            <a (hidden)="pos = null" (shown)="getSelectedLocationCoords(ele?.displayValue)"
               *ngIf="ele?.displayValue?.address?.position"
               [sbMapTooltip]="{type: 'Coordinates', data: { x: ele.displayValue.address.position.coordinates[0], y: ele.displayValue.address.position.coordinates[1] }}"
               class="link"
               container="body"
               ngbTooltip openDelay="300" placement="left left" tooltipClass="widthFix">
              <sb-icon class="mr-2" icon="locationStreet"></sb-icon>
              <span [innerHTML]="stringTransformation.addressToFullString(ele?.displayValue?.address) | truncate : 40"></span>
            </a>
            <span *ngIf="!ele?.displayValue?.address?.position"
                  [innerHTML]="stringTransformation.addressToFullString(ele?.displayValue?.address) | truncate : 40"></span>
          </td>
          <td
            *ngIf="currentSelection?.type === 'InventoryChannelDTO'">
            @for (marker of ele?.displayValue?.markers; track marker.id) {
              <div>{{ marker.resolution?.id }}</div>
            } @empty {
              {{ 'lang.globals.noData' | translate }}
            }
          </td>
          <td
            *ngIf="currentSelection?.type === 'InventoryMarkerDTO'">
            <div>{{ ele?.displayValue?.resolution?.id }}</div>

          </td>
          <td>
            <sb-aggregation-report [aggregatedData]="ele.report" [showCaption]="false"></sb-aggregation-report>
          </td>
          <td class="text-end sticky-col last-col tableBg">
            <button (click)="addToCart(ele)" *ngIf="!isInIntegratedContext && !isInModalContext"
                    [ngClass]="{'btn-hover-primary--active' : isInCart(ele)}"
                    class="btn btn-hover-primary mr-2">
              <sb-icon icon="shoppingkart"></sb-icon>
            </button>
            <!--
            <button (click)="showInventoryDetails(ele)" *ngIf="!isInModalContext"
                    class="btn btn-hover-primary mr-2">
              <sb-icon icon="details"></sb-icon>
            </button>
            -->
            <button (click)="addToFilter(ele)" [ngClass]="{'btn-hover-primary--active' : ele.collapsed === false}"
                    class="btn btn-hover-primary">
              <sb-icon *ngIf="ele.collapsed" class="icon-in-btn" icon="chevronDown"></sb-icon>
              <sb-icon *ngIf="!ele.collapsed" class="icon-in-btn" icon="chevronUp"></sb-icon>
            </button>
          </td>
        </tr>
        <tr *ngIf="ele?.collapsed === false" class="row-subtable">
          <td colspan="100">
            <div>
              <sb-comp-inventory-sublist [filter]="filter" [geoCull]="geoCull" [screenScope]="screenScope"
                                         [playerCull]="playerCull"></sb-comp-inventory-sublist>
            </div>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div card-footer>
    <div (pageChange)="pageChange($event)" (pageSizeChange)="setMaxSize($event)" *ngIf="paginationInitialized"
         [(page)]="page"
         [boundaryLinks]="boundaryLinks"
         [collectionSize]="collectionSize" [maxSize]="maxSize" [sizes]="sizes"
         sb-pagination>
      {{ paginationString }}
    </div>
  </div>
</sb-card>
